import React, { useContext, useState } from 'react';
import { Avatar, Dropdown, Button, Typography, Badge, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getRandomColorsBassedOnLetters } from '../../../../../../helper/colors';
import {
  QuestionOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  assignConversationToTeamMember,
  fetchTeamMembers,
} from '../../../../../../reduxToolkit/inboxSlice';
import NotificationContext from '../../../../../../providers/NotificationProvider';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../components/commonComponents/gxAntdToast/toastUtils';
const { Text } = Typography;

const ConversationAssignment = () => {
  const dispatch = useDispatch();
  const toast = useContext(NotificationContext);

  // selectors
  const {
    teamMembers,
    teamMembersLoading,
    selectedWebChatConversation,
    selectedWebChatTeam,
    activeUsers,
  } = useSelector((state) => state.inbox);
  const { currentBrand, currentUser, isSocketConnected } = useSelector(
    (state) => state.app,
  );
  const isTeamLead = selectedWebChatTeam?.role_name === 'T_LDR';

  const {
    id: selectedConversationId,
    // assigned_to_id,
    agent_engagement_status,
    details: {
      assigned_team_member: { id: assigned_to_id },
    },
  } = selectedWebChatConversation;

  // states
  const [open, setOpen] = useState(false);

  // Handle Functions
  const assignConversation = async (member_id) => {
    const params = {
      brand_id: currentBrand?.brand_id,
      team_id: selectedWebChatTeam?.team_id,
      conversation_id: selectedConversationId,
      member_id: member_id,
    };
    const res = await dispatch(assignConversationToTeamMember(params));
    if (
      res?.type === 'inbox/web_chat/assignConversationToTeamMember/fulfilled'
    ) {
      showSuccessToast(toast, 'Conversation assigned successfully', 2);
    } else {
      showErrorToast(toast, 'Conversation assigned failed', 2);
    }
  };

  // state Methods
  const handleDropdownChange = (dropValue) => {
    setOpen(dropValue);

    // if (dropValue === false) return;

    // const lastSelectedWebChatTeam = localStorage.getItem(
    //   'lastSelectedWebChatTeam',
    // );

    // if (
    //   selectedWebChatTeam?.team_id != lastSelectedWebChatTeam ||
    //   teamMembers.length === 0
    // ) {
    //   listTeamMembers();
    // }
  };

  return (
    <Dropdown
      menu={{
        onClick: (e) => {
          const selectedMember = teamMembers?.find(
            (member) => member.team_member_id.toString() === e.key,
          );
          assignConversation(selectedMember?.team_member_id);
        },
        items: teamMembers?.map((member) => {
          const { color, backgroundColor } = getRandomColorsBassedOnLetters(
            member.first_name + ' ' + (member.last_name || ''),
          );
          const isOnline =
            activeUsers?.find((user) => user?.user_id == member?.user_id)
              ?.status === 'connected';
          const isMe = member?.user_id == currentUser?.id;
          const AmIOnline = isMe && isSocketConnected;

          return {
            key: member.team_member_id.toString(),
            label: (
              <div className="flex items-center gap-2 p-1">
                {member?.profile_photo ? (
                  <Avatar src={member.profile_photo}></Avatar>
                ) : (
                  <Avatar
                    style={{
                      backgroundColor: backgroundColor,
                      verticalAlign: 'middle',
                      color: color,
                    }}
                    size="default"
                  >
                    {member.first_name?.[0]?.toUpperCase()}
                    {member.last_name?.[0]?.toUpperCase()}
                  </Avatar>
                )}

                <div className="flex flex-col">
                  <Text strong className="text-sm">
                    {isMe
                      ? 'Me'
                      : member.screen_name ||
                        `${member.first_name} ${member.last_name || ''}`.trim()}
                  </Text>
                  <Text type="secondary" className="text-xs">
                    {member?.email}
                  </Text>
                </div>
                <div
                  className={`w-2 h-2 rounded-full ml-auto ${
                    isOnline || AmIOnline ? 'bg-green-500' : 'bg-gray-400'
                  }`}
                />
              </div>
            ),
          };
        }),
        selectable: true,
        defaultSelectedKeys: assigned_to_id ? [assigned_to_id.toString()] : [],
      }}
      // load
      disabled={!isTeamLead}
      open={open}
      onOpenChange={handleDropdownChange}
      trigger={['click']}
      placement="bottomLeft"
      overlayClassName="team-members-dropdown"
    >
      <Button
        type="text"
        className="px-0"
        disabled={agent_engagement_status || !isTeamLead}
      >
        {assigned_to_id ? (
          <RenderSelectedMember
            member_id={assigned_to_id}
            teamMembers={teamMembers}
            currentUser={currentUser}
            isSocketConnected={isSocketConnected}
            activeUsers={activeUsers}
          />
        ) : (
          <Avatar icon={<UserAddOutlined />} />
        )}
      </Button>
    </Dropdown>
  );
};

export default ConversationAssignment;

const RenderSelectedMember = ({
  member_id,
  teamMembers,
  currentUser,
  isSocketConnected,
  activeUsers,
}) => {
  const member = teamMembers?.find(
    (member) => member.team_member_id == member_id,
  );
  const isMe = member?.user_id == currentUser?.id;
  const AmIOnline = isMe && isSocketConnected;
  const isOnline =
    activeUsers?.find((user) => user?.user_id == member?.user_id)?.status ===
    'connected';
  return (
    <Badge
      count={1}
      dot
      offset={[-30, 30]}
      color={AmIOnline || isOnline ? '#87d068' : '#ccc'}
      size="small"
    >
      <Tooltip title={`Assigned to ${isMe ? 'You' : member?.screen_name}`}>
        {member?.profile_photo ? (
          <Avatar
            className="cursor-pointer"
            src={member?.profile_photo}
            shape="square"
          />
        ) : (
          <Avatar
            className="cursor-pointer"
            icon={<UserDeleteOutlined />}
            shape="square"
          />
        )}
      </Tooltip>
    </Badge>
  );
};
